export default __webpack_public_path__ + "static/media/logo-black.89d93c3e.svg";